import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {AppService} from '../app.service';
declare let $: any;
declare let window: any;
declare let paypal: any;

@Component({
  selector: 'impressions-mobile',
  templateUrl: './impressionsMobile.component.html',
  styleUrls: ['./impressionsMobile.component.css', '../app.component.css']
})
export class ImpressionsMobileComponent implements OnInit, AfterViewChecked {
  customSel = 0;
  customPrice = 0;
  hasRenderedButton = false;
  //
  // runPayment = (data, actions) => {
  //   let custom = {
  //     user_id: this.app.user.id,
  //     card_id: this.app.selectedSavedCard.id,
  //     type: 2,
  //     uses: this.app.impressionCount,
  //     days_purchased: 0
  //   };
  //   let total = (this.app.impressionCount * .01);
  //   return actions.payment.create({
  //     payment: {
  //       transactions: [
  //         {
  //           amount: {
  //             total: total,
  //             currency: 'USD'
  //           },
  //           custom: JSON.stringify(custom),
  //         }
  //       ]
  //     }
  //   });
  // };
  // onAuthorize = (data, actions) => {
  //   console.log("On authorize?");
  //   return actions.payment.execute().then((payment) => {
  //     this.app.selectedSavedCard.paid_for = true;
  //     this.app.selectedSavedCard.impressions_left = this.app.selectedSavedCard.impressions_left + this.app.impressionCount;
  //     this.app.selectedSavedCard.advertisement = true;
  //     this.app.broadcast({event: 'purchaseFinished'});
  //     console.log("Card added: ", this.app.selectedSavedCard, " Impressions: ", this.app.impressionCount);
  //     console.log("Payment: ", payment);
  //     console.log("Thank you for your purchase!");
  //   })
  // };
  //
  // paypalConfig = {
  //   env: 'production',
  //   client: {
  //     sandbox: 'AdaH7zW6JiIdhABcw6h3zIVUseemY-3bfdtS28ALi9oWcxnM6z-Vgw4dJOoc_f_Fq-e6vLdLSjR0HSb6',
  //     production: 'ARF4qUYRK26BGsYAHsF7BzdKv3sLgn5T-GUDScBp5JEMbVI1v3YlJU8dUuMu6FC_oUiKIOyfPJXzvKbg'
  //   },
  //   locale: 'en_US',
  //   style: {
  //     size: 'large',
  //     color: 'gold',
  //     shape: 'rect',
  //     label: 'pay',
  //     tagline: 'true'
  //   },
  //   commit: true,
  //   payment: this.runPayment,
  //   onAuthorize: this.onAuthorize,
  //   onCancel: this.onCancel
  // };

  constructor(public app: AppService) {

  }

  ngOnInit() {

  }

  buyImpressions() {
    console.log("Buy impressions");
    this.app.fireWebViewEvent(3, this.app.selectedSavedCard.id, this.app.impressionCount, this.app.impressionCount);
  }

  allowedToBuyImpressions() {
    if (this.app.filterLocations) {
      if (this.app.selectedSavedCard.locations.length === 1) {
        if (this.app.selectedSavedCard.locations[0].level === 4) {
          return {"pointer-events" : 'none', 'opacity' : .5};
        }
      }
    }
    return {};
  }

  runPaymentCheck() {
    if (this.app.filterLocations) {
      if (this.app.selectedSavedCard.locations.length === 1) {
        if (this.app.selectedSavedCard.locations[0].level === 4) {
          this.showLocationSetupWrongError();
          return;
        }
      }
    }
    console.log("Good to go");
  }

  showLocationSetupWrongError() {
    alert("The location settings are incorrect. Please adjust the specific area(s) to show the card in or switch the card to show anywhere");
  }

  ngAfterViewChecked() {
    // if (!this.hasRenderedButton) {
    //   console.log("Should be rendering paypal button");
    //   paypal.Button.render(this.paypalConfig, '#paypal-buy-impressions');
    //   this.hasRenderedButton = true;
    // }
  }

  impressionChange() {
    console.log("Impressions changed");
    // this.updatePaypalButton();
  }
  //
  // updatePaypalButton() {
  //   $('#paypal-buy-impressions').html("");
  //   this.hasRenderedButton = false;
  // }

  onCancel(data, actions) {
    console.log("Payment canceled: ", data, actions.payment);
  }

  customStyle(val) {
    if (val === this.customSel) {
      return 'highlight';
    }
  }

  makeCustom(count, price) {
    this.customSel = count;
    this.customPrice = price;
    console.log("Make custom: ", this.customSel, this.customPrice);
    this.app.fireWebViewEvent(2, this.app.selectedSavedCard.id, count, price);
  }

  backToManage() {
    this.app.broadcast({event: 'setTertiaryOne'});
  }
}
